import { Tooltip } from "antd-v5";
import classNames from "classnames";
import { getVocabulary } from "components/Vocabulary";
// import { getVocabulary } from "components/Vocabulary";
// import { SEVERITY_COLOR } from "constants/Layout";
import useActiveSeveritiesKeys from "hooks/useActiveSeveritiesKeys";
import { capitalize, isEmpty, isUndefined, noop, reduce } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import { formatNumber } from "utils/numberUtil";
import { CellRenderers, renderTrend } from "utils/tableUtils";
import { updateURLSearch } from "utils/urlUtil";
import { BASE_SEVERITIES } from "views/Findings/Constants";

import ACSeverityTag, { SeverityType } from "ac-components/ACSeverityTag";
import { ACTriggerProps } from "ac-components/ACTrigger";

// import ACPopover from "ac-components/ac-popover/ACPopover";
import "./ACFindingSeverityBreakDownBar.less";

type payloadProps = {
  filters: any;
  pagination?: { page: number };
  groupBy?: string[] | undefined;
  savedSearch?: { id: number } | undefined;
};

type dataProps = {
  name: string;
  count: number;
  severity: Record<string, number>;
  riskScore: number | null;
};

type commonFiltersProps = {
  filters: {
    environmentName: string[];
    status: string[];
  };
  ignoreMitigated: boolean;
};

export interface FindingSeverityProps {
  findingSeverity: { [key: string]: number | null };
  activeSeverityKeys?: string[];
  payload?: payloadProps;
  clickable?: boolean;
  redirectionFindings?: (key: string) => void;
  showTrend?: boolean;
  trendDayDiff?: number;
  popupPlacement?: ACTriggerProps["placement"];
  data?: dataProps;
  TooltipComponent?: any;
  commonFilters?: commonFiltersProps;
  className?: string;
}
export default function ACFindingSeverityBreakDownBar({
  findingSeverity,
  activeSeverityKeys: _activeSeverityKeys,
  payload,
  clickable = true,
  redirectionFindings,
  showTrend,
  trendDayDiff,
  popupPlacement,
  data,
  TooltipComponent = undefined,
  commonFilters,
  className,
}: FindingSeverityProps) {
  const enabledSeverities = useActiveSeveritiesKeys();
  const activeSeverityKeys = _activeSeverityKeys || enabledSeverities;
  const NA = CellRenderers.VALUE_OR_NA();
  const shouldAllowClick =
    clickable && !isUndefined(findingSeverity) && findingSeverity !== NA;
  const history = useHistory();
  const total = reduce(
    activeSeverityKeys,
    (acc, curr) => {
      if (findingSeverity?.[curr]) {
        return acc + findingSeverity[curr]!;
      }
      return acc;
    },
    0,
  );

  const redirectToFindings = (type: string) => {
    const {
      filters,
      pagination = { page: 0 },
      groupBy = undefined,
      savedSearch = undefined,
    } = payload || {};
    const _filters = {
      ...filters,
      severity: type === "total" ? BASE_SEVERITIES : [capitalize(type)],
    };
    updateURLSearch(
      history,
      {
        filters: _filters,
        pagination: pagination,
        savedSearch: savedSearch,
        groupBy: groupBy,
      },
      "/findings",
    );
  };

  // const content = (
  //   <div className="ac-findings-severity-breakdown-container">
  //     {total !== 0 ? (
  //       <div
  //         className="ac-findings-severity-breakdown-bar-container"
  //         style={{ width: "128px" }}
  //       >
  //         {activeSeverityKeys.map((key) => {
  //           const severityValue = findingSeverity[key];
  //           const severityPercentage =
  //             Math.round((severityValue! / total) * 100) || 0;
  //           if (severityPercentage !== 0) {
  //             return (
  //               <div
  //                 className="ac-findings-severity-breakdown-bar"
  //                 style={{
  //                   width: `${severityPercentage}%`,
  //                   background:
  //                     SEVERITY_COLOR[key as keyof typeof SEVERITY_COLOR],
  //                 }}
  //               ></div>
  //             );
  //           }
  //           return null;
  //         })}
  //       </div>
  //     ) : (
  //       <div
  //         className="ac-findings-severity-breakdown-bar-container"
  //         style={{ width: "128px" }}
  //       >
  //         <div
  //           className="ac-findings-severity-breakdown-bar"
  //           style={{
  //             width: `100%`,
  //             background: "#10182813",
  //           }}
  //         ></div>
  //       </div>
  //     )}
  //     <div className="ac-findings-severity-breakdown-total">
  //       {formatNumber(total, "short")}
  //     </div>
  //   </div>
  // );

  // const renderSeverityCell = useCallback(
  //   (key: string, value: number | null) => (
  //     <td>
  //       {showTrend &&
  //         renderTrend(
  //           key,
  //           {},
  //           findingSeverity || {},
  //           total,
  //           true,
  //           false,
  //           true,
  //           trendDayDiff,
  //         )}
  //       <Tooltip
  //         placement="right"
  //         overlayStyle={{
  //           maxWidth: 550,
  //           maxHeight: 350,
  //           overflowY: "auto",
  //           overflowX: "hidden",
  //         }}
  //         title={
  //           TooltipComponent && !isEmpty(data) ? (
  //             <TooltipComponent
  //               commonFilters={commonFilters}
  //               severity={key}
  //               data={data}
  //             />
  //           ) : (
  //             `${key}: ${!findingSeverity || findingSeverity[key] === CellRenderers.VALUE_OR_NA() ? "No tool(s) configured" : formatNumber(value || 0, "long")}`
  //           )
  //         }
  //       >
  //         {value ? formatNumber(value ?? 0, "short") : 0}
  //       </Tooltip>
  //     </td>
  //   ),
  //   [
  //     showTrend,
  //     findingSeverity,
  //     total,
  //     trendDayDiff,
  //     TooltipComponent,
  //     data,
  //     commonFilters,
  //   ],
  // );

  // return (
  // <ACPopover
  //   trigger="hover"
  //   style={{ padding: "unset" }}
  //   placement={popupPlacement || "topLeft"}
  //   content={
  //     <table className="ac-findings-severity-breakdown-table">
  //       {activeSeverityKeys.map((key) => {
  //         return (
  //           <tr
  //             className={classNames({ clickable: clickable })}
  //             onClick={(e) => onClick(e, key)}
  //           >
  //             <td>
  //               <div
  //                 style={{
  //                   background:
  //                     SEVERITY_COLOR[key as keyof typeof SEVERITY_COLOR],
  //                 }}
  //                 className="ac-findings-severity-breakdown-table-bar"
  //               ></div>
  //             </td>
  //             <td>{getVocabulary(key)}</td>
  //             {renderSeverityCell(key, findingSeverity?.[key])}
  //           </tr>
  //         );
  //       })}
  //       <tr
  //         className={classNames(
  //           "ac-findings-severity-breakdown-table-total-row",
  //           { clickable: clickable },
  //         )}
  //         onClick={(e) => onClick(e, "total")}
  //       >
  //         <td></td>
  //         <td>Total</td>
  //         {renderSeverityCell("Total", total)}
  //       </tr>
  //     </table>
  //   }
  // >
  // </ACPopover>
  // );

  const onClick = (
    e: React.MouseEvent<HTMLDivElement | HTMLButtonElement, MouseEvent>,
    key: string,
  ) => {
    e.stopPropagation();
    if (!shouldAllowClick) return noop();
    redirectionFindings ? redirectionFindings(key) : redirectToFindings(key);
  };

  return (
    <div className={classNames("d-flex align-items-center", className)}>
      {activeSeverityKeys.map((key) => {
        const content = formatNumber(findingSeverity?.[key] ?? 0, "short");
        return (
          <>
            <Tooltip
              // placement="right"
              title={
                TooltipComponent && !isEmpty(data) ? (
                  <TooltipComponent
                    commonFilters={commonFilters}
                    severity={key}
                    data={data}
                  />
                ) : (
                  <div>
                    <div>
                      {getVocabulary(key)}:{" "}
                      {!findingSeverity ||
                      findingSeverity?.[key] === CellRenderers.VALUE_OR_NA()
                        ? "No tool(s) configured"
                        : formatNumber(findingSeverity?.[key] || 0, "long")}
                    </div>
                    {showTrend &&
                      renderTrend({
                        severityKey: key,
                        severity: findingSeverity || {},
                        totalCount: total,
                        newTrendDataFormat: true,
                        hideTrend: false,
                        showTrendTooltips: true,
                        trendDayDiff: trendDayDiff,
                      })}
                  </div>
                )
              }
            >
              <div onClick={(e) => onClick(e, key)}>
                {
                  <ACSeverityTag
                    className={classNames("ac-finding-severity-bar m-r-xs", {
                      clickable: clickable,
                    })}
                    value={key as SeverityType}
                    customValue={content}
                  />
                }
              </div>
            </Tooltip>
          </>
        );
      })}
      {
        <Tooltip title={`Total: ${formatNumber(total || 0, "long")}`}>
          <div
            onClick={(e) => onClick(e, "total")}
            className={classNames(
              "ac-finding-severity-bar ac-finding-severity-bar-total",
              { clickable: clickable },
            )}
          >
            T {formatNumber(total, "short")}
          </div>
        </Tooltip>
      }
    </div>
  );
}
